import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import ChatWidget from './ChatWidget';
import CookieConsent from './CookieConsent';
import WhatsAppButton from './WhatsAppButton';
import { SettingsProvider } from '../context/SettingsContext';

const PublicLayout = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 120);
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [location]);

  return (
    <SettingsProvider>
      <Header />
      <Outlet />
      <Footer />
      <ChatWidget />
      <WhatsAppButton />
      <CookieConsent />
    </SettingsProvider>
  );
};

export default PublicLayout;
